import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import LiveVerify from './components/LiveVerify';
import PinScan from './components/PinScan';
import ListingRadar from './components/ListingRadar';
import ProductMaster from './components/ProductMaster';
import Settings from './components/Settings';
import './App.css';

export default function App() {
  const { user, logout } = useAuth();
  const exportsEnabled = user ? user.exportsEnabled !== false : true;
  const canSeeExports = user?.role === 'admin' && exportsEnabled;
  const canSeeLiveVerify = user?.workspace === 'div2';
  const [page, setPage] = useState(canSeeExports ? 'exports' : (canSeeLiveVerify ? 'live' : 'master'));
  const [dark, setDark] = useState(false);

  useEffect(() => {
    if (!user) return;
    if (user.role === 'team' || user.exportsEnabled === false) setPage(canSeeLiveVerify ? 'live' : 'master');
  }, [user]);

  if (!user) return <Login />;

  const isAdmin = user.role === 'admin';

  return (
    <div className={dark ? 'app dark' : 'app'}>
      <nav className="topbar">
        <div className="tlogo">Adiko <span>Export</span></div>
        <div className="navtabs">
          {canSeeExports && <button className={page==='exports'?'navtab active':'navtab'} onClick={()=>setPage('exports')}>Exports Dashboard</button>}
          {canSeeLiveVerify && <button className={page==='live'?'navtab active':'navtab'} onClick={()=>setPage('live')}>Main Scraper</button>}
          {canSeeLiveVerify && <button className={page==='pins'?'navtab active':'navtab'} onClick={()=>setPage('pins')}>Pincode Scanner</button>}
          {canSeeLiveVerify && <button className={page==='radar'?'navtab active':'navtab'} onClick={()=>setPage('radar')}>Listing Radar</button>}
          <button className={page==='master'?'navtab active':'navtab'} onClick={()=>setPage('master')}>Product Master</button>
          <button className={page==='settings'?'navtab active':'navtab'} onClick={()=>setPage('settings')}>Settings</button>
        </div>
        <div className="tright">
          <div className="ubadge">Signed in as <strong>{user.username}</strong> · {user.role}</div>
          <button onClick={()=>setDark(!dark)} title={dark?"Light mode":"Dark mode"} style={{background:dark?"#3a3a3a":"#e8e8e8",border:"none",cursor:"pointer",borderRadius:20,width:52,height:28,position:"relative",transition:"background 0.3s",padding:0,display:"flex",alignItems:"center"}}>
              <span style={{position:"absolute",left:dark?"26px":"4px",top:"4px",width:20,height:20,borderRadius:"50%",background:"#fff",transition:"left 0.3s",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}>
                {dark ? "🌙" : "☀️"}
              </span>
            </button>
          <button className="lout" onClick={logout}>Sign out</button>
        </div>
      </nav>
      <main className="main-content">
        {page==='exports' && canSeeExports && <Dashboard role={user.role} dark={dark} />}
        {page==='live' && canSeeLiveVerify && <LiveVerify dark={dark} />}
        {page==='pins' && canSeeLiveVerify && <PinScan />}
        {page==='radar' && canSeeLiveVerify && <ListingRadar />}
        {page==='master' && <ProductMaster role={user.role} />}
        {page==='settings' && <Settings role={user.role} exportsEnabled={exportsEnabled} />}
      </main>
    </div>
  );
}
